import React from 'react'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'

const Select = ({
    label,
    altLabel,
    altLabelBottomLeft,
    altLabelBottomRight,
    options,
    onChange,
    error,
    value,
    defaultValue = '',
    ...props
}) => {
    const { t } = useTranslation()
    // Controlled when the caller tracks the value, uncontrolled otherwise. Handing
    // <select> both a value and a defaultValue makes React warn, and dropping the
    // value entirely loses the selection whenever the field remounts.
    const valueProps = value === undefined ? { defaultValue } : { value }
    return (
        <label className="form-control w-full ">
            <div className="label">
                <span className="label-text">
                    <Trans>{label}</Trans>
                </span>
                <span className="label-text-alt">
                    <Trans>{altLabel}</Trans>
                </span>
            </div>
            <select
                className={`select select-bordered ${
                    error ? 'select-error' : ''
                }`}
                placeholder="Select an option"
                onChange={(evt) => onChange(evt.target.value)}
                {...valueProps}>
                {/* An <option> can only hold text: react-dom 17 flattens element
                    children with string concatenation, so a <Trans> here renders as
                    "[object Object]" on the satellite sites. */}
                <option key="disabled_select" value={''} disabled={true}>
                    {t('Sélectionnez')}
                </option>
                {options.map((o) => {
                    return (
                        <option
                            key={o.value}
                            value={o.value}
                            disabled={o.disabled}>
                            {t(o.label)}
                        </option>
                    )
                })}
            </select>
            <div className="label">
                <span className="label-text-alt">
                    <Trans>{altLabelBottomLeft}</Trans>
                </span>
                <span className="label-text-alt">
                    <Trans>{altLabelBottomRight}</Trans>
                </span>
            </div>
        </label>
    )
}

export default Select
